import React from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

import config from '../config';
import { translate as t } from '../lib/I18n';
import { getBrandInfo } from '../lib/brand';
import { AppName } from '../constants/AppConstants';

import PaymentMethods from './payment/PaymentMethods';
import FeatureFlag from './general/FeatureFlag';
import ExternalLink from './general/ExternalLink';
import InternalLink from './general/InternalLink';

function FooterLink({ url = '', message = '', isInternal = false }) {
    const Link = isInternal ? InternalLink : ExternalLink;

    return url ? (
        <li>
            <Link
                href={url}
                message={message}
                className="footer__main-link"
            />
        </li>
    ) : null;
}

FooterLink.propTypes = {
    url: PropTypes.string,
    message: PropTypes.string,
    isInternal: PropTypes.bool,
};

const Footer = ({ hasFooterPoweredByOn }) => {
    const helpUrl =
        config.get('name') === AppName.DELAY_REPAY
            ? 'delayRepayUrl'
            : 'helpUrl';

    const internalLinks = config.get('enableFooterLinkInternal');
    const Link = internalLinks.includes('mainSiteUrl') ? InternalLink : ExternalLink;

    const getLinkProps = key => ({
        key,
        url: config.get(key),
        isInternal: internalLinks.includes(key),
    });

    const onOpenPreferences = () => {
        if (window.UC_UI) {
            window.UC_UI.showSecondLayer();
        }
    };

    const { isSouthEastern } = getBrandInfo();

    return (
        <footer
            className={ classnames(
                "container-fluid footer fx-powered-by-on hidden-print",
                {
                    "footer--with-powered-by-on": hasFooterPoweredByOn
                })
            }
        >
            <nav role="navigation">
                <ul className="pull-right no-margin list-inline list-styled">
                    <FooterLink
                        {...getLinkProps('legalUrl')}
                        message="footer.legal"
                    />
                    {isSouthEastern && (
                        <li>
                            <button
                                className="footer__link-btn"
                                type="button"
                                onClick={onOpenPreferences}
                            >
                                <span>Change Preferences</span>
                                <i className='otrl otrl-externallink' />
                            </button>
                        </li>
                    )}
                    <FooterLink
                        {...getLinkProps('accessibilityStatementUrl')}
                        message="footer.accessibilityStatement"
                    />
                    <FeatureFlag name="enableFooterOwnerLink">
                       <FooterLink
                            {...getLinkProps('ownerUrl')}
                            message="footer.owner"
                        />
                    </FeatureFlag>
                    <FeatureFlag name="enableFooterFaqsLink">
                        <FooterLink
                            {...getLinkProps('faqUrl')}
                            message="footer.faqs"
                        />
                    </FeatureFlag>
                    <FooterLink
                        {...getLinkProps('contactUrl')}
                        message="footer.contact"
                    />
                    <FooterLink
                        {...getLinkProps('helpUrl')}
                        url={config.get(helpUrl)}
                        message="global.banner.beta.help"
                    />
                </ul>
            </nav>

            <Link
                href={config.get('mainSiteUrl')}
                message={t('global.backToMainSite', {
                    brand: t('footer.link', null, t('app.owner'))
                })}
                className="footer__main-link pull-left"
            />

            <FeatureFlag name="enableFooterPaymentMethods">
                <PaymentMethods className="padding--horiz" />
            </FeatureFlag>
        </footer>
    );
};

Footer.propTypes = {
    hasFooterPoweredByOn: PropTypes.bool,
};

Footer.defaultProps = {
    hasFooterPoweredByOn: false,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js